import script from "./InstallWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallWizard.vue?vue&type=script&setup=true&lang=js"

import "./InstallWizard.vue?vue&type=style&index=0&id=6fbc3172&lang=scss"

const __exports__ = script;

export default __exports__